import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import Loader from '../../Components/Loader';

import { useAuth } from '../../Context/Context';

import icon2 from "../../Images/Icon/63.png";

import NoticiasHelper from '../../Helpers/Noticias';

const View = () => {
    const { setEditar } = useAuth();

    const [noticias, setNoticias] = useState([]);
    const [flag, setFlag] = useState(false);

    useEffect(() => {
        obtenerNoticias();
    }, []);

    const obtenerNoticias = async () => {
        let res = await NoticiasHelper.obtenerNoticias();
        if (res.success) {
            setNoticias(res.data);
            setFlag(true);
        } else {
            Swal.fire(
                'Error!',
                'No se lograron obtener las noticias, codigo: ' + res.code,
                'error'
            );
        }
    };

    const eliminarNoticia = id => {
        NoticiasHelper.eliminarNoticia(id);
    };

    const agregarNoticia = () => {
        let ventana = document.getElementById("ventana_editable_agregar");
        ventana.className = "ventana_editable col s3";
        let vista = document.getElementById("vistas_generales");
        vista.className = "col s9";
        let cerrar = document.getElementById("invisible_cerrar_agregar");
        cerrar.className = "invisible_cerrar_activado";
    };

    const editarNoticia = noticia => {
        let ventana = document.getElementById("ventana_editable_editar");
        ventana.className = "ventana_editable col s3";
        let vista = document.getElementById("vistas_generales");
        vista.className = "col s9";
        let cerrar = document.getElementById("invisible_cerrar");
        cerrar.className = "invisible_cerrar_activado";
        setEditar(noticia);
    };

    return (
        <div id='vistas_generales' className='col s12' style={{ padding: "0" }}>
            <div className='container center'>
                <p className='titulo_solicitud' style={{ textAlign: "center" }}>
                    Noticias
                </p>
                {!flag ? (
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "60vh" }}>
                        <Loader />
                    </div>
                ) : (
                    <div>
                        <p style={{ marginLeft: "25px" }} className='texto_solicitud'>
                            Imagen
                        </p>
                        <div>
                            {noticias.map(noticia => (
                                <div className='box_solicitud' key={noticia._id}>
                                    <div className='row'>
                                        <div className='col s10'>
                                            <div style={{ marginLeft: "25px" }}>
                                                <p className='texto_solicitud'>
                                                    {noticia.imagen}
                                                </p>
                                            </div>
                                        </div>
                                        <div className='col s2'>
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", paddingRight: "25px" }}>
                                                <img style={{ cursor: "pointer" }} onClick={() => { eliminarNoticia(noticia._id); }} src={icon2} alt="" />
                                                <button onClick={() => { editarNoticia(noticia); }} className='caja_status' style={{ backgroundColor: "#00496C", border: "none" }}>
                                                    <p>EDITAR</p>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <div className='boton_2_nv'>
                        <button onClick={agregarNoticia}>
                            <p>Agregar noticia</p>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default View;
